export default __webpack_public_path__ + "static/media/logo.5f5d5947.png";